import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from "react-responsive";
import cx from 'classnames';

class Image extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    const { onClick, buttonIndex } = this.props;

    onClick(buttonIndex, e);
  }

  render() {
    const { data: imgData, swipeable, id, name } = this.props;

    const imgSrc = '/nl_nl/watersystems/assets/images/questions/' + imgData.image;
    const classes = cx('picture picture--question', {
      'picture--swipeable': swipeable,
    });

    return (
      <div>
        <picture className={classes} id={id} name={'group' + name} >
          <source srcSet={imgSrc} />
          <MediaQuery maxWidth={767}>
            <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" id={id} name={'group' + name} value={id} onClick={this.handleOnChange} alt="" />
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <img src={imgSrc} alt="" id={id} name={'group' + name} value={id} onClick={this.handleOnChange} />
          </MediaQuery>
        </picture>
        
      </div>
    );
  }
}

Image.propTypes = {
  data: PropTypes.object.isRequired,
  swipeable: PropTypes.bool.isRequired,
};

Image.defaultProps = {
  swipeable: false,
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/selectButton/Image.js